import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { StoredFile } from '../../model/file';
import { FileProvider } from '../file.provider';
import { I18N } from 'ess-plugin-base';
import { UIService } from '../../ui.service';

@Component({
    selector: 'file-card',
    templateUrl: './file.card.html',
    styleUrls: ['./file.card.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class FileCard {

    @Input()
    file: StoredFile = null;

    @Input()
    up: boolean = false;

    @Output('select')
    onSelect: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    @Output('edit')
    onEdit: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    @Output('delete')
    onDelete: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    @Output('move')
    onMove: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    @Output('open')
    onOpen: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    @Output('share')
    onShare: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    /*Nobel 2025-08-18 Shady Files*/
    @Input()
    rename: boolean = true

    @Input()
    del: boolean = true

    @Input()
    transfer: boolean = true

    @Input()
    shar: boolean = true;

    // @Output('link')
    // onLink: EventEmitter<StoredFile> = new EventEmitter<StoredFile>();

    showing: boolean = null;
    downloading: boolean;
    progress: number = 0;

    constructor(private fileProvider: FileProvider, private ui: UIService, public i18n: I18N) {
    }

    select(file: StoredFile) {
        this.onSelect.emit(file);

        this.showing = (this.showing)? null : true;
    }

    download(file: StoredFile) {
        // console.log(file.filename);
        // this.fileProvider.download(file);

        if (!file || !file.filename || !file.guid) return;

        let download = this.fileProvider.downloadProgress(file.filename, file.guid);
        this.progress = 0;
        this.downloading = true;

        download.progress.subscribe({
            next: (progress) => {
                this.progress = progress;
            },
            complete: () => {
                this.progress = 100;
                setTimeout(() => { this.downloading = null; }, 2000);

                this.fileProvider.writeContents(download.array, file.filename, 'application/octet-stream');
                // download.blob;
            },
            error: (err) => {
                this.progress = 0;
                setTimeout(() => { this.downloading = null; }, 2000);
                console.log(err);
                this.ui.error( this.i18n.get('file.download_error', 'File could not be downloaded.'));
            }
        })
    }

    edit(file: StoredFile) {
        // console.log("Clicked", file);
        if (file && file.guid && this.onEdit.observers.length) {
            this.onEdit.emit(file);
        }
    }

    delete(file: StoredFile) {
        // console.log("Clicked", file);
        if (file && file.guid && this.onEdit.observers.length) {
            this.onDelete.emit(file);
        }
    }

    move(file: StoredFile) {
        if (file && file.guid && this.onMove.observers.length) {
            this.onMove.emit(file);
        }
    }

    open(file: StoredFile) {
        if (file && file.guid && this.onOpen.observers.length) {
            this.onOpen.emit(file);
        }
    }

    share(file: StoredFile) {
        if (file && file.guid && this.onShare.observers.length) {
            this.onShare.emit(file);
        }
    }

    // link(file: StoredFile) {
    //     if (file && file.guid && this.onLink.observers.length) {
    //         this.onLink.emit(file);
    //     }
    // }

    getExtension(file: StoredFile): string {
        if (file && file.filename && file.size > 0) {
            return file.filename.slice(file.filename.lastIndexOf('.') + 1);
        }
        if (file) {
            return 'folder';
        }
        return null;
    }
}